import { Box, Container, Divider, Grid, IconButton, Stack, Typography } from "@mui/material";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.svg";
import appStore from "../../../assets/images/app-store-button.svg";
import googlePlay from "../../../assets/images/google-play-button.svg";
import FooterPayments from "./FooterPayments";
import { useTranslation } from "react-i18next";

const socialItems = [
  { label: "Facebook", Icon: FacebookRoundedIcon },
  { label: "Instagram", Icon: InstagramIcon },
  { label: "LinkedIn", Icon: LinkedInIcon },
  { label: "YouTube", Icon: YouTubeIcon },
  { label: "X", Icon: TwitterIcon },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation("footer");
  const footerGroups = [
    {
      title: t("directRent"),
      links: [
        { label: t("aboutUs"), to: "/about-us" },
        { label: t("howItWorks"), to: "/#howItWork" },
        { label: t("contact"), to: "/contact-us" },
        { label: t("browseCategories"), to: "/categories" },
      ],
    },
    {
      title: t("marketplace"),
      links: [
        { label: t("browseRentals"), to: "/browse-listing" },
        { label: t("listItem"), to: "/add-new-product" },
        { label: t("popularRentals"), to: "/popular-products" },
        { label: t("rentalGuarantee"), to: "/terms-of-service#guarantee" },
      ],
    },
    {
      title: t("helpLegal"),
      links: [
        { label: t("helpCenter"), to: "/contact-us" },
        { label: t("termsOfService"), to: "/terms-of-service" },
        { label: t("privacy-policy"), to: "/privacy-policy" },
        { label: t("safetyTrust"), to: "/terms-of-service#guarantee" },
      ],
    },
  ];

  return (
    <Box component="footer" sx={{ backgroundColor: "#f4f5f5", color: "secondary.dark" }}>
      <Container maxWidth="xl" sx={{ py: { xs: 5, md: 6 } }}>
        <Grid container spacing={{ xs: 4, md: 5 }}>
          <Grid item xs={12} md={3}>
            <Stack spacing={2} sx={{ alignItems: "flex-start" }}>
              <Link to="/" aria-label="Direct Rent home">
                <img src={logo} alt="Direct Rent" style={{ width: 150, height: 58, objectFit: "contain", objectPosition: "left center" }} />
              </Link>
              <Typography sx={{ color: "text.secondary", maxWidth: 280, fontSize: 14, lineHeight: 1.7 }}>
                {t("description")}
              </Typography>
            </Stack>
          </Grid>

          {footerGroups.map((group) => (
            <Grid item xs={6} sm={4} md={2} key={group.title}>
              <Typography sx={{ fontFamily: "Poppins-Bold", fontSize: 15, mb: 1.5 }}>{group.title}</Typography>
              <Stack spacing={1.05}>
                {group.links.map((item) => (
                  <Typography
                    component={Link}
                    to={item.to}
                    key={item.label}
                    sx={{ color: "text.secondary", textDecoration: "none", fontSize: 14, "&:hover": { color: "primary.main" } }}
                  >
                    {item.label}
                  </Typography>
                ))}
              </Stack>
            </Grid>
          ))}

          <Grid item xs={12} md={3}>
            <Typography sx={{ fontFamily: "Poppins-Bold", fontSize: 15, mb: 1.25 }}>{t("followDirectRent")}</Typography>
            <Stack direction="row" sx={{ gap: 1, flexWrap: "wrap" }}>
              {socialItems.map(({ label, Icon }) => (
                <IconButton
                  component={Link}
                  to="/contact-us"
                  aria-label={label}
                  key={label}
                  sx={{
                    width: 42,
                    height: 42,
                    color: "primary.main",
                    border: "1px solid rgba(254, 31, 2, 0.38)",
                    "&:hover": { color: "#fff", backgroundColor: "primary.main" },
                  }}
                >
                  <Icon sx={{ fontSize: 20 }} />
                </IconButton>
              ))}
            </Stack>

            <Stack direction="row" sx={{ mt: 2.5, gap: 1, flexWrap: "wrap" }}>
              <img src={appStore} alt="Download on the App Store" loading="lazy" style={{ width: 116, height: 38, objectFit: "contain" }} />
              <img src={googlePlay} alt="Get it on Google Play" loading="lazy" style={{ width: 116, height: 38, objectFit: "contain" }} />
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(7, 31, 40, 0.12)" }} />

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ alignItems: "center", justifyContent: "space-between" }}>
          <Typography sx={{ color: "text.secondary", fontSize: 13, textAlign: "center" }}>
            © {currentYear} Direct Rent. {t("allRightsReserved")}
          </Typography>
          <FooterPayments />
        </Stack>
      </Container>
    </Box>
  );
};
